import React, { useRef, memo, useCallback } from 'react';
import { Paperclip } from 'lucide-react';

interface FileUploadButtonProps {
    onFileSelect: (files: File[]) => void;
}

const FileUploadButton: React.FC<FileUploadButtonProps> = memo(({ onFileSelect }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(e.target.files || []);
        onFileSelect(selectedFiles);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, [onFileSelect]);

    const handleUploadClick = useCallback(() => {
        fileInputRef.current?.click();
    }, []);

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileSelect}
                multiple
                style={{ display: 'none' }}
                // 与后端白名单对齐；zip 单件后端解压展开为合并案例（友好性⑨）
                accept="image/*,.tif,.tiff,.pdf,.docx,.zip"
            />

            <button className="upload-button" onClick={handleUploadClick}>
                <Paperclip size={20} />
            </button>
        </>
    );
});

FileUploadButton.displayName = 'FileUploadButton';

export default FileUploadButton;